import { CircularProgress, Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { PrincipalLayouts } from "../../../layouts"
import { fetchData } from "../../helpers/getData/fetchData"
import { AddReservation } from './AddReservation'

export const GetDataAddForm = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { t } = useTranslation('global')
    const [userList, setUserList] = useState('isLoading')
    const [userId, setUserId] = useState(1)
    const [nameList, setNameList] = useState('isLoading')
    const [vehiclesList, setVehicles] = useState('isLoading')

    useEffect(() => {
        fetchData(setUserList, '/user/getListNameAndId?type=Club', t)
        fetchData(setNameList, `/companies/listNameQuery?name=${userId}`, t)
        fetchData(setVehicles, '/vehicle/nameList', t)
    }, [t, userId])

    const paramToArray= searchParams.get('reservation').split(',')
    const dataToNumber = paramToArray.map(num => Number(num))

    return (
        <PrincipalLayouts>
            {
                userList !== 'isLoading' && nameList !== 'isLoading' && vehiclesList !== 'isLoading' ?
                    <AddReservation userList={userList?.filter(data => !dataToNumber.includes(data.id))} setUserId={setUserId} companiesList={nameList} vehiclesList={vehiclesList} userId={userId}/>
                    :
                    <Stack width='100%' alignItems='center' marginTop='100px'>
                        <CircularProgress />
                    </Stack>

            }
        </PrincipalLayouts>
    )
}
